import { render, staticRenderFns } from "./StokKampanya.vue?vue&type=template&id=25c8fc66"
import script from "./StokKampanya.vue?vue&type=script&lang=js"
export * from "./StokKampanya.vue?vue&type=script&lang=js"
import style0 from "./StokKampanya.vue?vue&type=style&index=0&id=25c8fc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports